import { ReactNode } from 'react';

interface ScrollShadowsProps {
  canScrollLeft?: boolean;
  canScrollRight?: boolean;
  children: ReactNode;
  canScrollUp?: boolean;
  canScrollDown?: boolean;
  className?: string;
  offsets?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const shadowClasses = {
  right:
    'pointer-events-none absolute inset-y-0 z-10 w-3 [background:linear-gradient(to_left,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0.08)_40%,rgba(0,0,0,0.03)_70%,transparent_100%)] transition-opacity duration-200',
  left: 'pointer-events-none absolute inset-y-0 z-10 w-3 [background:linear-gradient(to_right,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0.08)_40%,rgba(0,0,0,0.03)_70%,transparent_100%)] transition-opacity duration-200',
  top: 'pointer-events-none absolute inset-x-0 z-10 h-3 [background:linear-gradient(to_bottom,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0.08)_40%,rgba(0,0,0,0.03)_70%,transparent_100%)] transition-opacity duration-200',

  bottom:
    'pointer-events-none absolute inset-x-0 z-10 h-3 [background:linear-gradient(to_top,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0.08)_40%,rgba(0,0,0,0.03)_70%,transparent_100%)] transition-opacity duration-200',
};

const Shadow = ({
  side,
  visible,
  offset,
}: {
  side: 'left' | 'right' | 'top' | 'bottom';
  visible: boolean;
  offset: number;
}) => (
  <div
    aria-hidden
    style={{ [side]: offset }}
    className={`${shadowClasses[side]} ${visible ? 'opacity-100' : 'opacity-0'}`}
  />
);

export const ScrollShadows = ({
  canScrollLeft = false,
  canScrollRight = false,
  canScrollUp = false,
  canScrollDown = false,
  children,
  className,
  offsets = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
}: ScrollShadowsProps) => (
  <div className={`relative ${className}`}>
    {children}
    <Shadow side="right" visible={canScrollRight} offset={offsets.right} />
    <Shadow side="left" visible={canScrollLeft} offset={offsets.left} />
    <Shadow side="top" visible={canScrollUp} offset={offsets.top} />
    <Shadow side="bottom" visible={canScrollDown} offset={offsets.bottom} />
  </div>
);
